module.exports = __webpack_public_path__ + "img/icons BFr_35.7032ddfd.png";